import React, {Component} from 'react'
import {Card, CardBody, CardTitle, Button} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast, ToastContainer} from "react-toastify"
import {withRouter} from 'react-router-dom'

import mutation from '../../../queries/server/mutations/reset_password'

class ResetPassword extends Component{

    state = {
        newPassword: '',
        confirmPassword: ''
    }

    render(){

        const {code} = this.props.match.params

        return(
            <div className="container-fluid flex-fullheight">
                <div className="d-flex flex-grow-1 flex-column justify-content-center align-items-center">
                    <Card className="shadow-sm p-3 mb-5 bg-white rounded login-card">
                        <CardTitle>Reset Password</CardTitle>
                        <div className="d-flex align-items-center justify-content-center">
                            <Mutation mutation={mutation}>
                                {(mutationFunc, {loading}) => (
                                    <AvForm
                                        className="d-flex flex-column"
                                        style={{flex: 1}}
                                        onValidSubmit={() => {
                                            mutationFunc({variables: {...this.state, code}})
                                                .then(() => {
                                                    toast.success('Password Successfully Updated', {autoClose: 2000})
                                                    this.props.history.push('/login')
                                                    this.setState({newPassword: '', confirmPassword: ''})
                                                })
                                                .catch(e => {
                                                    toast.error(e.message, {autoClose: false})
                                                })
                                        }}
                                    >
                                        <AvField
                                            required
                                            type="password"
                                            name="password"
                                            label="New Password*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({newPassword: evt.target.value})}
                                        />

                                        <AvField
                                            required
                                            type="password"
                                            name="confirmPassword"
                                            label="Confirm Password*"
                                            bsSize="sm"
                                            errorMessage="Required"
                                            onChange={(evt) => this.setState({confirmPassword: evt.target.value})}
                                        />

                                        <div className="d-flex flex-row justify-content-between">
                                            <Button
                                                size="sm"
                                                type="button"
                                                color="link"
                                                onClick={() => this.props.history.push('/login')}
                                            >
                                                Back to Login
                                            </Button>
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={loading}
                                            >
                                                {loading ? 'Updating Password...' : 'Reset Password'}{' '}
                                                {loading && <FontAwesomeIcon
                                                    color="#fff"
                                                    icon="spinner"
                                                    spin
                                                />}
                                            </Button>
                                        </div>
                                    </AvForm>
                                )}

                            </Mutation>
                        </div>
                    </Card>
                </div>
            </div>
        )
    }

}

ResetPassword = withRouter(ResetPassword)

export default ResetPassword